import TerritoryList from '../components/territory/List'
import TerritoryCreate from '../components/territory/Create'

export default [
  { name: 'TerritoryList', path: '/territories/', component: TerritoryList, props: { pageTitle: 'Territory List' } },
  { name: 'TerritoryCreate', path: '/territories/create', component: TerritoryCreate, props: { pageTitle: 'Territory Create' } }
]
